/**
 * „Eine Mail ist raus“ (User 22.10.2026, Vorgang 44: „Ich habe auf eine Mail
 * geantwortet, und da ist die Mail nicht da, erst nach dem Reload.“).
 *
 * Das Verfassen-Fenster meldet hier jeden erfolgreichen Versand — egal ob die
 * Antwort des Servers sofort kam oder erst über die Statusabfrage (T-340) —
 * samt der Vorgänge, an denen die Mail jetzt hängt bzw. aus denen heraus sie
 * geschrieben wurde. Ein offener Vorgang lädt daraufhin seinen Verlauf nach.
 *
 * Nötig, weil Antworten meist über das Lesefenster entstehen (Vorgang → Mail
 * öffnen → Antworten): Dieses Verfassen-Fenster kennt keinen Rückruf in den
 * Vorgang. Der Socket-Weg (`vorgang:dirty`) deckt es zusätzlich ab, fällt aber
 * mit der Verbindung aus.
 */
export type MailGesendet = {
    /** Vorgänge, an die die Mail verknüpft wurde oder aus denen sie stammt. */
    vorgangIds: number[];
};

type Hoerer = (e: MailGesendet) => void;

const hoerer = new Set<Hoerer>();

export function meldeMailGesendet(e: MailGesendet): void {
    for (const h of Array.from(hoerer)) {
        try {
            h(e);
        } catch {
            /* ein kaputter Hörer darf die anderen nicht aufhalten */
        }
    }
}

export function abonniereMailGesendet(h: Hoerer): () => void {
    hoerer.add(h);
    return () => {
        hoerer.delete(h);
    };
}

/** Vorgangs-Ids aus Versandergebnis und Fensterkontext — ohne Dubletten und Unsinn. */
export function vorgaengeDesVersands(
    linkedVorgangIds: ReadonlyArray<number> | null | undefined,
    ...kontext: Array<number | null | undefined>
): number[] {
    const ids = new Set<number>();
    for (const id of [...(linkedVorgangIds ?? []), ...kontext]) {
        if (typeof id === "number" && Number.isFinite(id) && id > 0) ids.add(id);
    }
    return Array.from(ids);
}
